/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  RegisterAffiliateReferrerOptions,
  RegisterAffiliateReferrerResponses,
} from '../types/RegisterAffiliateReferrer'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description ADMIN or INTEGRATOR required, within tenant permissions. Accepts an optional custom referral_code and generates one when omitted or empty. Codes are stored uppercase and globally unique. Duplicate membership or code returns 409. Users may supply the code at signup or assign it later through POST /v1/affiliate_referrals/self.
 * @summary Register an existing user as a referrer
 * {@link /v1/affiliate_programs/:program_id/referrers}
 */
export function registerAffiliateReferrer<ThrowOnError extends boolean = true>(
  options: Options<RegisterAffiliateReferrerOptions, ThrowOnError>,
): Unwrappable<RequestResult<RegisterAffiliateReferrerResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/affiliate_programs/{program_id}/referrers',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<RegisterAffiliateReferrerResponses, ThrowOnError>>,
  )
}
